export default function getEnv () {
  return process.env.CDN_ENV as string
}
